import { useEffect } from 'react';

export const SEOHead = () => {
  useEffect(() => {
    // Primary Meta Tags
    document.title = "Fahad Al Tamimi Law Firm | Saudi Arabia Business Lawyer & Corporate Attorney Riyadh";
    
    const metaTags = [
      // Primary Meta Description
      { name: 'description', content: 'Premier Saudi Arabia law firm specializing in corporate law, foreign investment (MISA), business licensing, and cross-border transactions. Licensed attorneys in Riyadh with 15+ years serving Fortune 500 companies, investors, and multinational corporations. Fast-track services with AI-powered CRM. Book consultation.' },
      
      // Keywords (still relevant for some search engines and AI)
      { name: 'keywords', content: 'Saudi Arabia lawyer, law firm Riyadh, business lawyer Saudi Arabia, corporate attorney KSA, MISA license, foreign investment Saudi Arabia, commercial lawyer Riyadh, legal services Saudi Arabia, Vision 2030 legal advisor, cross-border legal services, Fahad Al Tamimi, employment law Saudi Arabia, company formation KSA, trademark registration Saudi Arabia, contract lawyer Riyadh, dispute resolution Saudi Arabia, M&A lawyer KSA, regulatory compliance Saudi Arabia, international business lawyer' },
      
      // Author and Publisher
      { name: 'author', content: 'Fahad Al Tamimi Law Firm' },
      { name: 'publisher', content: 'Fahad Al Tamimi Law Firm' },
      
      // Geo Tags for Local SEO
      { name: 'geo.region', content: 'SA-01' },
      { name: 'geo.placename', content: 'Riyadh' },
      { name: 'geo.position', content: '24.7136;46.6753' },
      { name: 'ICBM', content: '24.7136, 46.6753' },
      
      // Language and Country
      { name: 'language', content: 'English' },
      { name: 'geo.country', content: 'SA' },
      
      // Robots and Crawling
      { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
      { name: 'googlebot', content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1' },
      { name: 'bingbot', content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1' },
      
      // Mobile Optimization
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'theme-color', content: '#c3a565' },
      
      // Apple Mobile Web App
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
      { name: 'apple-mobile-web-app-title', content: 'Fahad Al Tamimi Law' },
      
      // Open Graph / Facebook
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://www.altamimilaw.com' },
      { property: 'og:title', content: 'Fahad Al Tamimi Law Firm | Leading Saudi Arabia Corporate Lawyer & Business Attorney' },
      { property: 'og:description', content: 'Premier law firm in Riyadh specializing in foreign investment, MISA licensing, corporate law, and cross-border transactions. Serving Fortune 500 companies and international investors with AI-powered legal services.' },
      { property: 'og:image', content: 'https://www.altamimilaw.com/og-image.jpg' },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' },
      { property: 'og:locale', content: 'en_US' },
      { property: 'og:locale:alternate', content: 'ar_SA' },
      { property: 'og:site_name', content: 'Fahad Al Tamimi Law Firm' },
      
      // Twitter Card
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:url', content: 'https://www.altamimilaw.com' },
      { name: 'twitter:title', content: 'Fahad Al Tamimi Law Firm | Saudi Arabia Business Lawyer' },
      { name: 'twitter:description', content: 'Premier Saudi law firm for foreign investment, corporate law, and MISA licensing. 15+ years serving international businesses in Riyadh.' },
      { name: 'twitter:image', content: 'https://www.altamimilaw.com/twitter-image.jpg' },
      
      // Additional SEO Tags
      { name: 'revisit-after', content: '7 days' },
      { name: 'distribution', content: 'global' },
      { name: 'rating', content: 'general' },
      { name: 'referrer', content: 'no-referrer-when-downgrade' },
      
      // Canonical URL
      { rel: 'canonical', href: 'https://www.altamimilaw.com' },
      
      // AI Search Optimization Tags
      { name: 'classification', content: 'Legal Services, Corporate Law, Business Consulting' },
      { name: 'category', content: 'Legal Services' },
      { name: 'coverage', content: 'Saudi Arabia, GCC, Middle East' },
      { name: 'target', content: 'B2B, Corporate Clients, International Investors' },
    ];

    // Apply meta tags
    metaTags.forEach(tag => {
      let element = tag.name 
        ? document.querySelector(`meta[name="${tag.name}"]`)
        : tag.property
        ? document.querySelector(`meta[property="${tag.property}"]`)
        : tag.rel
        ? document.querySelector(`link[rel="${tag.rel}"]`)
        : null;

      if (!element) {
        element = document.createElement(tag.rel ? 'link' : 'meta');
        if (tag.name) element.setAttribute('name', tag.name);
        if (tag.property) element.setAttribute('property', tag.property);
        if (tag.rel) element.setAttribute('rel', tag.rel);
        document.head.appendChild(element);
      }

      if (tag.content) element.setAttribute('content', tag.content);
      if (tag.href) element.setAttribute('href', tag.href);
    });

    // JSON-LD Structured Data for Rich Snippets
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        // Main Organization
        {
          "@type": "LegalService",
          "@id": "https://www.altamimilaw.com/#organization",
          "name": "Fahad Al Tamimi Law Firm",
          "alternateName": "Al Tamimi Law Firm",
          "url": "https://www.altamimilaw.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.altamimilaw.com/logo.png",
            "width": 250,
            "height": 60
          },
          "image": "https://www.altamimilaw.com/og-image.jpg",
          "description": "Premier law firm in Saudi Arabia specializing in corporate law, foreign investment, MISA licensing, and cross-border legal services for international businesses and investors.",
          "telephone": "+966-50-000-0000",
          "email": "info@altamimilaw.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "King Fahd Road, Al Olaya District",
            "addressLocality": "Riyadh",
            "addressRegion": "Riyadh Province",
            "postalCode": "11564",
            "addressCountry": "SA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "24.7136",
            "longitude": "46.6753"
          },
          "areaServed": [
            {
              "@type": "Country",
              "name": "Saudi Arabia"
            },
            {
              "@type": "GeoCircle",
              "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": "24.7136",
                "longitude": "46.6753"
              },
              "geoRadius": "1000000"
            }
          ],
          "serviceArea": {
            "@type": "Country",
            "name": "Saudi Arabia"
          },
          "priceRange": "SAR 800 - SAR 50,000+",
          "paymentAccepted": "Cash, Credit Card, Bank Transfer",
          "currenciesAccepted": "SAR, USD",
          "openingHours": "Mo-Th 09:00-18:00, Su 09:00-18:00",
          "slogan": "Your Strategic Partner for Saudi Expansion",
          "foundingDate": "2009",
          "numberOfEmployees": {
            "@type": "QuantitativeValue",
            "value": "15"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "127",
            "bestRating": "5",
            "worstRating": "1"
          },
          "sameAs": [
            "https://www.linkedin.com/company/altamimilaw",
            "https://twitter.com/altamimilaw",
            "https://www.facebook.com/altamimilaw"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Legal Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Corporate Law Services",
                  "description": "Corporate governance, company formation, and commercial law advisory"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Foreign Investment & MISA Licensing",
                  "description": "Foreign investment licensing, regulatory compliance, and market entry strategy"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Employment & Labor Law",
                  "description": "Employment contracts, Saudization compliance, and labor dispute resolution"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Mergers & Acquisitions",
                  "description": "M&A advisory, due diligence, and transaction structuring"
                }
              }
            ]
          }
        },
        // Attorney/Person Schema
        {
          "@type": "Attorney",
          "name": "Fahad Rashed Al Tamimi",
          "jobTitle": "Commercial, Corporate Lawyer & Notary",
          "worksFor": {
            "@id": "https://www.altamimilaw.com/#organization"
          },
          "knowsAbout": [
            "Corporate Law",
            "Commercial Law",
            "Foreign Investment",
            "MISA Licensing",
            "Saudi Business Law",
            "Cross-border Transactions",
            "Regulatory Compliance",
            "Vision 2030 Regulations"
          ],
          "alumniOf": "King Saud University",
          "memberOf": "Saudi Bar Association",
          "award": "Legal 500 Recognized",
          "email": "fahad@altamimilaw.com"
        },
        // LocalBusiness Schema
        {
          "@type": "LocalBusiness",
          "@id": "https://www.altamimilaw.com/#localbusiness",
          "name": "Fahad Al Tamimi Law Firm",
          "image": "https://www.altamimilaw.com/office.jpg",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "King Fahd Road, Al Olaya District",
            "addressLocality": "Riyadh",
            "addressRegion": "Riyadh Province",
            "postalCode": "11564",
            "addressCountry": "SA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "24.7136",
            "longitude": "46.6753"
          },
          "url": "https://www.altamimilaw.com",
          "telephone": "+966-50-000-0000",
          "priceRange": "SAR 800 - SAR 50,000+",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
              "opens": "09:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Sunday",
              "opens": "09:00",
              "closes": "18:00"
            }
          ]
        },
        // ProfessionalService Schema
        {
          "@type": "ProfessionalService",
          "name": "Fahad Al Tamimi Law Firm - Legal Consulting",
          "description": "Professional legal services for corporate clients, investors, and international businesses operating in Saudi Arabia",
          "provider": {
            "@id": "https://www.altamimilaw.com/#organization"
          },
          "serviceType": "Legal Services",
          "areaServed": "Saudi Arabia",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Express Legal Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Business License Registration",
                  "description": "Fast-track business registration and licensing in Saudi Arabia"
                },
                "price": "3500",
                "priceCurrency": "SAR"
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "24-Hour Contract Review",
                  "description": "Urgent contract review and legal risk assessment"
                },
                "price": "2000",
                "priceCurrency": "SAR"
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Legal Consultation",
                  "description": "Expert legal advice on business matters"
                },
                "price": "1500",
                "priceCurrency": "SAR"
              }
            ]
          }
        },
        // WebSite Schema
        {
          "@type": "WebSite",
          "@id": "https://www.altamimilaw.com/#website",
          "url": "https://www.altamimilaw.com",
          "name": "Fahad Al Tamimi Law Firm",
          "description": "Premier law firm in Saudi Arabia for corporate law, foreign investment, and business legal services",
          "publisher": {
            "@id": "https://www.altamimilaw.com/#organization"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.altamimilaw.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          },
          "inLanguage": "en-US"
        },
        // WebPage Schema
        {
          "@type": "WebPage",
          "@id": "https://www.altamimilaw.com/#webpage",
          "url": "https://www.altamimilaw.com",
          "name": "Fahad Al Tamimi Law Firm | Saudi Arabia Business Lawyer & Corporate Attorney",
          "isPartOf": {
            "@id": "https://www.altamimilaw.com/#website"
          },
          "about": {
            "@id": "https://www.altamimilaw.com/#organization"
          },
          "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": "https://www.altamimilaw.com/og-image.jpg"
          },
          "datePublished": "2024-01-01T00:00:00+03:00",
          "dateModified": "2024-12-30T00:00:00+03:00",
          "description": "Premier Saudi Arabia law firm specializing in corporate law, foreign investment, MISA licensing, and cross-border transactions for international businesses.",
          "inLanguage": "en-US",
          "potentialAction": [
            {
              "@type": "ReadAction",
              "target": ["https://www.altamimilaw.com"]
            }
          ]
        },
        // BreadcrumbList Schema
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.altamimilaw.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Services",
              "item": "https://www.altamimilaw.com#services"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "About",
              "item": "https://www.altamimilaw.com#about"
            }
          ]
        },
        // FAQPage Schema (for AI search engines)
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What legal services does Fahad Al Tamimi Law Firm provide?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide comprehensive legal services including corporate law, foreign investment & MISA licensing, employment law, mergers & acquisitions, regulatory compliance, intellectual property, dispute resolution, contract management, and cross-border transactions for businesses operating in Saudi Arabia."
              }
            },
            {
              "@type": "Question",
              "name": "How can foreign investors get a MISA license in Saudi Arabia?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Foreign investors can obtain MISA (Ministry of Investment Saudi Arabia) licensing through our comprehensive service which includes market entry strategy, regulatory compliance, documentation preparation, government liaison, and full licensing within 7-10 business days. We handle all aspects from application to approval."
              }
            },
            {
              "@type": "Question",
              "name": "What are your legal service fees?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our express services range from SAR 800 for Power of Attorney to SAR 6,000 for MISA License applications. We offer transparent pricing with both fixed-fee and hourly rate options. Contact us for a customized quote based on your specific legal needs."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you provide legal services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We offer fast-track services including same-day legal consultations, 24-hour contract reviews, 1-2 day employment contract drafting, and 3-5 day business license registration. Most urgent matters receive same-day response with expedited processing available."
              }
            },
            {
              "@type": "Question",
              "name": "Do you serve international businesses and investors?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we specialize in serving Fortune 500 companies, international investors, and multinational corporations entering the Saudi market. We provide cross-border legal services, bilingual support (Arabic/English), and deep understanding of both Saudi and international legal frameworks."
              }
            }
          ]
        }
      ]
    };

    // Insert or update JSON-LD script
    let scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(structuredData);

    // Add alternate language tags
    const alternateLangs = [
      { hreflang: 'en', href: 'https://www.altamimilaw.com' },
      { hreflang: 'ar', href: 'https://www.altamimilaw.com/ar' },
      { hreflang: 'x-default', href: 'https://www.altamimilaw.com' }
    ];

    alternateLangs.forEach(lang => {
      let linkElement = document.querySelector(`link[hreflang="${lang.hreflang}"]`);
      if (!linkElement) {
        linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'alternate');
        linkElement.setAttribute('hreflang', lang.hreflang);
        linkElement.setAttribute('href', lang.href);
        document.head.appendChild(linkElement);
      }
    });

  }, []);

  return null;
};
